/** The not-found piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { NotFoundEvents } from './contract';
import { NotFoundView } from './NotFoundView';
import { useNotFound } from './useNotFound';

export function NotFound(props: PieceInput<NotFoundEvents>) {
  return <NotFoundView {...useNotFound(props)} />;
}
